document.addEventListener("DOMContentLoaded", function () {
    const imageGalleries = document.querySelectorAll(".image-gallery");

    if (imageGalleries.length > 0) {
        // Loop through each gallery and initialize Swiper
        imageGalleries.forEach((gallery, index) => {
            const mainSwiper = gallery.querySelector(".gallery-main");
            const thumbsSwiper = gallery.querySelector(".gallery-thumbs");

            // Add dynamic classes
            mainSwiper.classList.add("gallery-main-" + index);
            thumbsSwiper.classList.add("gallery-thumbs-" + index);

            // Initialize Thumbs swiper
            const thumbsInstance = new Swiper(".gallery-thumbs-" + index, {
                slidesPerView: 2.5,
                centeredSlides: false,
                spaceBetween: 12,
                watchSlidesProgress: false,
                navigation: {
                    nextEl: ".gallery-thumbs-next",
                    prevEl: ".gallery-thumbs-prev",
                },
                breakpoints: {
                    576: {
                        slidesPerView: 3.5,
                       
                    },
                    768: {
                        slidesPerView: 4.5,
                    },
                    992: {
                        slidesPerView: 5.5,
                    },
                },
            });

            // Initialize Main swiper
            const mainInstance = new Swiper(".gallery-main-" + index, {
                slidesPerView: 1,
                spaceBetween: 0,
                grabCursor: true,
                effect: "fade", // Use fade effect for smooth transition
                fadeEffect: {
                    crossFade: true,
                },
                thumbs: {
                    swiper: thumbsInstance,
                },
            });
        });
    }
});
